import * as _m0 from "protobufjs/minimal";
export let Action;
(function (Action) {
  Action[Action["ACTION_FREE"] = 0] = "ACTION_FREE";
  Action[Action["ACTION_LIQUID_STAKE"] = 1] = "ACTION_LIQUID_STAKE";
  Action[Action["ACTION_DELEGATE_STAKE"] = 2] = "ACTION_DELEGATE_STAKE";
  Action[Action["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Action || (Action = {}));
export let ActionSDKType;
(function (ActionSDKType) {
  ActionSDKType[ActionSDKType["ACTION_FREE"] = 0] = "ACTION_FREE";
  ActionSDKType[ActionSDKType["ACTION_LIQUID_STAKE"] = 1] = "ACTION_LIQUID_STAKE";
  ActionSDKType[ActionSDKType["ACTION_DELEGATE_STAKE"] = 2] = "ACTION_DELEGATE_STAKE";
  ActionSDKType[ActionSDKType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ActionSDKType || (ActionSDKType = {}));
export function actionFromJSON(object) {
  switch (object) {
    case 0:
    case "ACTION_FREE":
      return Action.ACTION_FREE;
    case 1:
    case "ACTION_LIQUID_STAKE":
      return Action.ACTION_LIQUID_STAKE;
    case 2:
    case "ACTION_DELEGATE_STAKE":
      return Action.ACTION_DELEGATE_STAKE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Action.UNRECOGNIZED;
  }
}
export function actionToJSON(object) {
  switch (object) {
    case Action.ACTION_FREE:
      return "ACTION_FREE";
    case Action.ACTION_LIQUID_STAKE:
      return "ACTION_LIQUID_STAKE";
    case Action.ACTION_DELEGATE_STAKE:
      return "ACTION_DELEGATE_STAKE";
    default:
      return "UNKNOWN";
  }
}
/** A Claim Records is the metadata of claim data per address */

function createBaseClaimRecord() {
  return {
    airdropIdentifier: "",
    address: "",
    weight: "",
    actionCompleted: []
  };
}
export const ClaimRecord = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.airdropIdentifier !== "") {
      writer.uint32(10).string(message.airdropIdentifier);
    }
    if (message.address !== "") {
      writer.uint32(18).string(message.address);
    }
    if (message.weight !== "") {
      writer.uint32(26).string(message.weight);
    }
    writer.uint32(34).fork();
    for (const v of message.actionCompleted) {
      writer.bool(v);
    }
    writer.ldelim();
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.airdropIdentifier = reader.string();
          break;
        case 2:
          message.address = reader.string();
          break;
        case 3:
          message.weight = reader.string();
          break;
        case 4:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.actionCompleted.push(reader.bool());
            }
          } else {
            message.actionCompleted.push(reader.bool());
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$airdropIdenti, _object$address, _object$weight, _object$actionComplet;
    const message = createBaseClaimRecord();
    message.airdropIdentifier = (_object$airdropIdenti = object.airdropIdentifier) !== null && _object$airdropIdenti !== void 0 ? _object$airdropIdenti : "";
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.weight = (_object$weight = object.weight) !== null && _object$weight !== void 0 ? _object$weight : "";
    message.actionCompleted = ((_object$actionComplet = object.actionCompleted) === null || _object$actionComplet === void 0 ? void 0 : _object$actionComplet.map(e => e)) || [];
    return message;
  }
};